export default __webpack_public_path__ + "static/media/4.d53c7097.png";